export default __webpack_public_path__ + "static/media/zhu.d88afa11.png";